"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@iconify/react");
var _material = require("@mui/material");
var _constants = require("util/constants");
var _DocumentIconModule = _interopRequireDefault(require("./DocumentIcon.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DocumentIcon = exports.DocumentIcon = function DocumentIcon(_ref) {
  var fileType = _ref.fileType;
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _DocumentIconModule["default"].documentIcon
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "material-symbols-light:".concat(fileType === _constants.TYPE_FOLDER ? "folder-outline-rounded" : "draft-outline-rounded"),
    width: 20,
    height: 20,
    color: "#1C1B1F"
  }));
};